import { IBrief } from "@shared/lib/types/brief";
import { IPricingWorkload } from "@shared/lib/types/pricingWorkload";
import { CircularProgress, Table, TableTitleLayout, Typography } from "@shared/ui";
import { Flex, Input } from "antd";
import { ColumnsType } from "antd/es/table";
import { Search } from "lucide-react";
import { MY_PRICING_TABLE_META, MyPricingSegment } from "../lib/constants";
import styles from "./MyPricing.module.scss";
import { MyPricingStatsSection } from "./MyPricingStatsSection";

const { Title, Text } = Typography;

type MyPricingBriefsSectionProps = {
  isLoading: boolean;
  segment: MyPricingSegment;
  onSegmentChange: (segment: MyPricingSegment) => void;
  segmentOptions: { label: string; value: MyPricingSegment }[];
  getStatValue: (key: keyof IPricingWorkload) => number | undefined;
  columns: ColumnsType<IBrief>;
  briefs: IBrief[];
  isFetching: boolean;
  pageNo: number;
  pageSize: number;
  totaldata: number;
  onPaginationChange: (page: number, size: number) => void;
  searchQuery?: string;
  onSearchQueryChange?: (value: string) => void;
};

export function MyPricingBriefsSection({
  isLoading,
  segment,
  onSegmentChange,
  segmentOptions,
  getStatValue,
  columns,
  briefs,
  isFetching,
  pageNo,
  pageSize,
  totaldata,
  onPaginationChange,
  searchQuery,
  onSearchQueryChange,
}: MyPricingBriefsSectionProps) {
  const tableMeta = MY_PRICING_TABLE_META[segment];

  return (
    <Flex vertical gap={20}>
      <CircularProgress spinning={isLoading}>
        <section className={styles.contentSection}>

          <MyPricingStatsSection
            segment={segment}
            getStatValue={getStatValue}
          />

          <div className={styles.tableCard}>
            <div className={styles.tableCardHeader}>
              <Title level={5} className={styles.tableCardTitle}>
                {tableMeta.title}
              </Title>
              <Text type="secondary" className={styles.tableCardDescription}>
                {tableMeta.description}
              </Text>
            </div>

            <Table
              columns={columns}
              dataSource={briefs}
              title={() => <TableTitleLayout 
                filterComponent={<Flex gap={10} style={{width: "100%"}}>
                  <Input
          value={searchQuery}
          onChange={(event) => onSearchQueryChange?.(event.target.value)}
          placeholder="Brief name, project, creator handle, or contact number…"
          allowClear
          style={{width: 300}}
          prefix={<Search size={14}/>}
        />
        <div
            className={styles.tabList}
            role="tablist"
            aria-label="Brief list view"
          >
            {segmentOptions.map((tab) => {
              const isActive = segment === tab.value;
              return (
                <button
                  key={tab.value}
                  type="button"
                  role="tab"
                  aria-selected={isActive}
                  className={`${styles.tabButton} ${isActive ? styles.tabButtonActive : ""}`}
                  onClick={() => onSegmentChange(tab.value as MyPricingSegment)}
                >
                  {tab.label}
                </button>
              );
            })}
          </div>
                </Flex>}
              />}
              rowKey="_id"
              loading={isFetching}
              pagination={{
                current: pageNo,
                pageSize,
                total: totaldata,
                onChange: onPaginationChange,
              }}
              // className={styles.briefsTable}
              scroll={{ x: 800 }}
              locale={{ emptyText: tableMeta.emptyText }}
            />
          </div>
        </section>
      </CircularProgress>
    </Flex>
  );
}
